"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var domain_exports = {};
__export(domain_exports, {
  Domain: () => Domain,
  Domains: () => Domains
});
module.exports = __toCommonJS(domain_exports);
var Domain = /* @__PURE__ */ ((Domain2) => {
  Domain2["Message"] = "communication.message";
  Domain2["MessageCreated"] = "communication.message_created";
  Domain2["MessagesGroup"] = "communication.messages_group";
  Domain2["Attachment"] = "communication.attachment";
  Domain2["Patch"] = "communication.patch";
  Domain2["Reaction"] = "communication.reaction";
  Domain2["Thread"] = "communication.thread";
  Domain2["Notification"] = "communication.notification";
  Domain2["NotificationContext"] = "communication.notification_context";
  Domain2["Collaborator"] = "communication.collaborator";
  Domain2["Label"] = "communication.label";
  Domain2["Peer"] = "communication.peer";
  return Domain2;
})(Domain || {});
const Domains = Object.values(Domain);
//# sourceMappingURL=domain.js.map
